"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Destroy(_a) {
    var event = _a.event, events = _a.events, setEvents = _a.setEvents, onSuccess = _a.onSuccess;
    var _b = ra_fetch_1.useApi('media')
        .records(setEvents, events.data)
        .delete('events', {
        id: event.data.id,
        channel_id: event.data.channel_id,
    }), destroy = _b[0], submitDestroy = _b[1];
    return react_1.default.createElement("div", null,
        react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', icon: 'trash', className: 'mr-2', disabled: destroy.submitting, onClick: function () { return submitDestroy().then(function (response) {
                if (response.errors.length < 1) {
                    onSuccess();
                }
            }); } }));
}
exports.default = Destroy;
